// extracted by mini-css-extract-plugin
export default {"main":"_52ff5b82ac","tit":"b54feb2cba","maintitle":"ced250d4f1","ylw":"bcc197e101","white":"d11b92e4b8","mv_title":"_9b55aca174","mv_nc":"_7fb0f86dfe","mv_in":"_652c2e963f"};